import { module as BaseModule } from 'modujs'
import Lenis from '@studio-freight/lenis'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    this.scroller = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 2,
      content: this.el,
      wrapper: this.el.parentNode,
    })

    this.scroller.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      this.scroller.raf(time * 1000)
    })

    function raf(time) {
      this.scroller.raf(time)
      requestAnimationFrame(raf.bind(this))
    }

    requestAnimationFrame(raf.bind(this))
  }
}
